import {createEntityAdapter, EntityAdapter} from '@ngrx/entity';
import {MengeneinheitExtended} from '../../interfaces/mengeneinheit-extended.interface';


export const mengeneinheitEntitiesAdapter: EntityAdapter<MengeneinheitExtended> = createEntityAdapter<MengeneinheitExtended>({
  selectId: (mengeneinheit: MengeneinheitExtended) => mengeneinheit.betriebId + '-' + mengeneinheit.nummer,
});
